/* Equipment Express ambulance configurator. Native Shopify contact submission. */
(() => {
  'use strict';
  const initialize = (root) => {
    if (root.dataset.kitReady) return;
    root.dataset.kitReady = 'true';
    const storageKey = `ee-ambulance-kit:v1:${root.dataset.storageKey}`;
    const storage = {
      read() { try { return JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { return null; } },
      write(data) { try { sessionStorage.setItem(storageKey, JSON.stringify(data)); } catch (_) { /* The form works without storage. */ } },
      clear() { try { sessionStorage.removeItem(storageKey); } catch (_) {} }
    };
    const success = root.querySelector('[data-kit-success]');
    if (success) { storage.clear(); success.focus({preventScroll: true}); return; }
    const form = root.querySelector('form');
    if (!form) return;
    const choices = Array.from(root.querySelectorAll('[data-kit-choice]'));
    const transportNone = root.querySelector('[data-kit-transport-none]');
    const summary = root.querySelector('[data-kit-summary]');
    const count = root.querySelector('[data-kit-count]');
    const empty = root.querySelector('[data-kit-empty]');
    const announcement = root.querySelector('[data-kit-announcement]');
    const message = root.querySelector('[data-kit-message]');
    const zip = root.querySelector('[data-kit-zip]');
    const saved = storage.read();
    if (saved && Array.isArray(saved.keys)) {
      choices.forEach(choice => { choice.checked = saved.keys.includes(choice.dataset.key); });
      if (!choices.some(choice => choice.dataset.kind === 'transport' && choice.checked)) transportNone.checked = true;
    }
    const selected = () => choices.filter(choice => choice.checked);
    const makeMessage = (items) => {
      const lines = ['BUILD YOUR OWN AMBULANCE — QUOTE REQUEST', '', 'Please quote the following package:', ''];
      items.forEach(choice => {
        lines.push(`${choice.dataset.kind === 'monitor' ? 'Base monitor' : 'Add-on'}: ${choice.dataset.title} — quantity 1`);
        if (choice.dataset.productHandle) lines.push(`Product handle: ${choice.dataset.productHandle}`);
      });
      if (!items.some(choice => choice.dataset.kind === 'transport')) lines.push('Patient handling: using existing stretcher and loading system.');
      lines.push('', `Shipping ZIP / postal code: ${zip.value.trim().toUpperCase() || 'See shipping ZIP field'}`, '', 'Please include package pricing, availability, configuration/accessory details and shipping. Confirm vehicle fit and installation if a patient-handling option is selected.');
      return lines.join('\n');
    };
    const update = (announce = false) => {
      const items = selected();
      summary.replaceChildren();
      items.forEach(choice => {
        const li = document.createElement('li');
        const text = document.createElement('div');
        const category = document.createElement('small');
        category.textContent = choice.dataset.kind === 'monitor' ? 'BASE MONITOR · 1' : 'ADD-ON · 1';
        const title = document.createElement('strong'); title.textContent = choice.dataset.title;
        text.append(category, title); li.append(text);
        if (choice.dataset.kind !== 'monitor') {
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'ee-kit-summary__remove';
          remove.textContent = '×'; remove.setAttribute('aria-label', `Remove ${choice.dataset.title}`);
          remove.addEventListener('click', () => {
            choice.checked = false;
            if (choice.dataset.kind === 'transport') transportNone.checked = true;
            update(true); choice.focus({preventScroll: true});
          });
          li.append(remove);
        }
        summary.append(li);
      });
      empty.hidden = items.length > 0;
      const hasMonitor = items.some(choice => choice.dataset.kind === 'monitor');
      count.textContent = hasMonitor ? `${items.length} ${items.length === 1 ? 'item' : 'items'} selected` : 'Choose a monitor to start';
      message.value = makeMessage(items);
      storage.write({keys: items.map(choice => choice.dataset.key)}); // Equipment choices only; no email or postal code.
      if (announce) announcement.textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'} in your kit.${hasMonitor ? '' : ' Choose your base monitor.'}`;
    };
    choices.forEach(choice => choice.addEventListener('change', () => update(true)));
    transportNone.addEventListener('change', () => update(true));
    zip.addEventListener('input', () => { message.value = makeMessage(selected()); });
    zip.addEventListener('change', () => { zip.value = zip.value.trim().toUpperCase(); message.value = makeMessage(selected()); });
    form.addEventListener('submit', (event) => {
      zip.value = zip.value.trim().toUpperCase();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      update();
      // Let Shopify handle the POST, spam protection, errors and real success response.
    });
    update();
    const errors = root.querySelector('[data-kit-errors]');
    if (errors) errors.focus({preventScroll: true});
  };
  const scan = (scope = document) => {
    if (scope.matches && scope.matches('[data-ambulance-kit]')) initialize(scope);
    scope.querySelectorAll('[data-ambulance-kit]').forEach(initialize);
  };
  if (!window.eeAmbulanceKitLoaded) {
    window.eeAmbulanceKitLoaded = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
    document.addEventListener('shopify:section:load', event => scan(event.target));
  } else scan();
})();
